<script>
import con from '@services/connection'
import { comunicacaoPush } from '@constants/URL'
import Title from '@components/section-title'
import rules from '@constants/Rules'
import Vue from 'vue'
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'

export default {
  components: {
    Title,
  },
  props: {
    bus: {
      type: Object,
      default: null,
      required: true,
    },
  },
  data() {
    return {
      busModal: new Vue(),
      titulo: '',
      corpo: '',
      clientes: [],
      rules: rules,
      loading: false,
    }
  },
  created() {
    if (this.bus) {
      this.bus.$on(MODAL.SEND_PUSH, this.open)
    }
    GlobalBus.$on(MODAL.SEND_PUSH, this.open)
  },
  methods: {
    open(l, def, conta) {
      console.log('Abrir modal push')
      if (def === 'att') {
        this.titulo = 'Informações desatualizadas'
        this.corpo =
          'Por favor, entre no aplicativo para atualizar sua carteira'
      } else if (def === 'attAccounts' && conta) {
        this.titulo = `Conta ${conta.nome}`
        this.corpo =
          conta.status === 'ok'
            ? 'Por favor, entre no aplicativo para atualizar sua carteira'
            : conta.status
      } else {
        this.titulo = ''
        this.corpo = ''
      }
      if (l.id) {
        this.clientes = [l.id]
      } else if (['string', 'number'].includes(typeof l)) {
        this.clientes = [l]
      } else {
        this.clientes = l
      }
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
      this.busModal.$emit('dialog', true)
    },
    async enviar() {
      if (this.loading) {
        return
      }
      if (this.$refs.form.validate()) {
        this.loading = true
        const data = {
          conteudo: this.corpo,
          nome: this.titulo,
          clientes: JSON.stringify(this.clientes),
        }
        const r = await con.post(comunicacaoPush.enviar, data)
        if (r.status === 200) {
          this.busModal.$emit('dialog', false)
          this.$showSnack({
            text: 'Notificação enviada com sucesso',
            button: true,
          })
        } else {
          this.$showSnack({
            text: 'Não foi possível enviar a notificação no momento',
            button: true,
          })
        }
        this.loading = false
      }
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" persistent>
    <Title title="Enviar notificação" />

    <div>
      <v-form ref="form" @submit.prevent>
        <v-text-field
          v-model="titulo"
          label="Titulo*"
          :rules="[rules.required]"
        >
        </v-text-field>
        <!-- @keydown.enter="enviar" -->
        <v-textarea v-model="corpo" label="Corpo*" :rules="[rules.required]" />
      </v-form>
    </div>

    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close"> Cancelar </BaseButton>
      <BaseButton primary :loading="loading" @click="enviar">
        Enviar
      </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>


